import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6412c44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ss-tela-titulo" }, [
      /*#__PURE__*/_createElementVNode("h1", null, "Empresas")
    ])
  ])
], -1))
const _hoisted_5 = { class: "ss-tela-conteudo" }
const _hoisted_6 = {
  key: 0,
  style: {"margin-left":"10px"}
}
const _hoisted_7 = {
  class: "ant-row",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_8 = { class: "ant-col ant-col-xs-20 ant-col-xl-10" }
const _hoisted_9 = {
  class: "ant-col ant-col-xs-2 ant-col-xl-2",
  style: {"display":"flex"}
}
const _hoisted_10 = {
  class: "ss-card",
  style: {"text-align":"left"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  title: "Informe o CPF/CNPJ da empresa que você deseja convidar",
  class: "ss-card-tela-titulo"
}, "Informe o CPF/CNPJ da empresa que você deseja convidar", -1))
const _hoisted_12 = {
  class: "ant-row",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_13 = { class: "ant-col ant-col-xs-20 ant-col-xl-10" }
const _hoisted_14 = {
  class: "ant-col ant-col-xs-2 ant-col-xl-2",
  style: {"display":"flex"}
}
const _hoisted_15 = {
  key: 2,
  style: {"display":"flex","text-align":"left"}
}
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-5 ss-display-flex" }
const _hoisted_18 = { class: "ss-empresa-texto" }
const _hoisted_19 = {
  class: "ss-empresa-texto",
  style: {"font-size":"23px"}
}
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-14 ss-separador-p10 ss-display-flex" }
const _hoisted_21 = {
  key: 0,
  class: "ss-empresa-texto"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Razão Social:", -1))
const _hoisted_23 = { class: "ss-empresa-texto" }
const _hoisted_24 = { class: "ss-empresa-texto" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Código/Nome Exibição:", -1))
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-5 ss-separador-p10" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "ant-row" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_31 = {
  key: 1,
  class: "ss-card ss-card-space"
}
const _hoisted_32 = { class: "ant-row ss-alinhar-itens-centro" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-5 ss-alinhar-centro" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "ss-imagem-responssiva",
    width: "150",
    src: "/static/img/ilustracoes/multi-empresas.png",
    alt: "Criar Grupo de Empresas"
  })
], -1))
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-19" }
const _hoisted_35 = { class: "ss-mensagem-informativa ss-alinhar-texto-esquerda" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Aproveite os Benefícios do Multi-Empresas", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Centralizar a Gestão:", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Facilitar a Contabilidade:", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Otimizar Processos:", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Personalizar Acessos:", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = { class: "ant-row" }
const _hoisted_48 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_49 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Criar", -1))
const _hoisted_51 = [
  _hoisted_50
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_campo_cpf_cnpj = _resolveComponent("campo-cpf-cnpj")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_empresa_dados_cadastrais_modal = _resolveComponent("empresa-dados-cadastrais-modal")!
  const _component_adicionar_empresa_grupo_modal = _resolveComponent("adicionar-empresa-grupo-modal")!
  const _component_configuracao_documentos_fiscais_eletronicos_modal = _resolveComponent("configuracao-documentos-fiscais-eletronicos-modal")!
  const _component_plano_assinatura_empresa_modal = _resolveComponent("plano-assinatura-empresa-modal")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_a_skeleton, {
            active: "",
            loading: _ctx.state.buscandoDados,
            paragraph: { rows: 15 }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                ((_ctx.state.grupoEmpresa.codigo > 0))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      ((_ctx.state.editandoNomeGrupo))
                        ? (_openBlock(), _createBlock(_component_a_spin, {
                            key: 0,
                            spinning: _ctx.state.atualizandoNomeGrupo
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                  _createVNode(_component_a_input, {
                                    id: "NomeGrupoEmpresa",
                                    value: _ctx.state.grupoEmpresa.nome,
                                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.grupoEmpresa.nome) = $event)),
                                    bordered: false,
                                    placeholder: "Digite o nome do Grupo"
                                  }, null, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(_component_a_tooltip, {
                                    placement: "top",
                                    title: "Salvar"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("a", {
                                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmarEdicaoNomeGrupo && _ctx.confirmarEdicaoNomeGrupo(...args))),
                                        class: "ss-icones-acoes"
                                      }, [
                                        _createVNode(_component_icone, {
                                          style: {"font-size":"24px"},
                                          nome: "correto-circulo"
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_tooltip, {
                                    placement: "top",
                                    title: "Cancelar"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("a", {
                                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelarEdicaoNomeGrupo && _ctx.cancelarEdicaoNomeGrupo(...args))),
                                        class: "ss-icones-acoes"
                                      }, [
                                        _createVNode(_component_icone, {
                                          style: {"font-size":"24px"},
                                          nome: "fechar-circulo"
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]),
                            _: 1
                          }, 8, ["spinning"]))
                        : _createCommentVNode("", true),
                      ((_ctx.state.digitandoConviteMultiEmpresas))
                        ? (_openBlock(), _createBlock(_component_a_spin, {
                            key: 1,
                            spinning: _ctx.state.enviandoConviteMultiEmpresas
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_10, [
                                _hoisted_11,
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_component_campo_cpf_cnpj, {
                                      valor: _ctx.state.cpfCnjConviteMultiEmpresas,
                                      "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.cpfCnjConviteMultiEmpresas) = $event))
                                    }, null, 8, ["valor"])
                                  ]),
                                  _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_a_tooltip, {
                                      placement: "top",
                                      title: "Enviar convite"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("a", {
                                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.enviarConviteMultiEmpresas && _ctx.enviarConviteMultiEmpresas(...args))),
                                          class: "ss-icones-acoes"
                                        }, [
                                          _createVNode(_component_icone, {
                                            style: {"font-size":"24px"},
                                            nome: "correto-circulo"
                                          })
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_tooltip, {
                                      placement: "top",
                                      title: "Cancelar"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("a", {
                                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelarConviteMultiEmpresa && _ctx.cancelarConviteMultiEmpresa(...args))),
                                          class: "ss-icones-acoes"
                                        }, [
                                          _createVNode(_component_icone, {
                                            style: {"font-size":"24px"},
                                            nome: "fechar-circulo"
                                          })
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ])
                            ]),
                            _: 1
                          }, 8, ["spinning"]))
                        : (_openBlock(), _createElementBlock("h1", _hoisted_15, [
                            _createTextVNode(_toDisplayString(_ctx.state.grupoEmpresa.nome) + " ", 1),
                            _createVNode(_component_a_tooltip, {
                              placement: "right",
                              title: "Editar nome do Grupo de Empresas"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.iniciarEdicaoNomeGrupo && _ctx.iniciarEdicaoNomeGrupo(...args))),
                                  class: "ss-icones-acoes"
                                }, [
                                  _createVNode(_component_icone, {
                                    style: {"font-size":"20px"},
                                    nome: "editar"
                                  })
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_tooltip, {
                              placement: "right",
                              title: "Convidar uma empresa para participar do Grupo"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.iniciarConviteMultiEmpresa && _ctx.iniciarConviteMultiEmpresa(...args))),
                                  class: "ss-icones-acoes"
                                }, [
                                  _createVNode(_component_icone, {
                                    style: {"font-size":"20px"},
                                    nome: "enviar"
                                  })
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_tooltip, {
                              placement: "right",
                              title: "Copiar Token do Grupo Multi-empresas"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.copiarTokenGrupoEmpresa && _ctx.copiarTokenGrupoEmpresa(...args))),
                                  class: "ss-icones-acoes"
                                }, [
                                  _createVNode(_component_icone, {
                                    style: {"font-size":"20px"},
                                    nome: "copiar"
                                  })
                                ])
                              ]),
                              _: 1
                            })
                          ]))
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.listaEmpresas, (empresa) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "ss-card ss-card-space",
                    key: empresa.codigo
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.UtilitarioGeral.documentoIdentificacaoCPFouCNPJ(empresa.cpfCnpj)), 1),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(empresa.cpfCnpj)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", null, [
                          (empresa.cpfCnpj.length === 14)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                _hoisted_22,
                                _createTextVNode(" " + _toDisplayString(empresa.razaoSocial), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_23, [
                            _createElementVNode("b", null, _toDisplayString(empresa.cpfCnpj.length === 14 ? 'Nome fantasia:' : 'Nome completo'), 1),
                            _createTextVNode(" " + _toDisplayString(empresa.nomeFantasia), 1)
                          ]),
                          _createElementVNode("span", _hoisted_24, [
                            _hoisted_25,
                            _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioGeral.montaExibicaoEmpresa(empresa.codigoExibicao, empresa.nomeExibicao)), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "ant-btn ant-btn-block ant-btn-secondary ss-margin-botoes ss-btn-acao-destaque",
                          onClick: ($event: any) => (_ctx.editarEmpresa(empresa.codigo))
                        }, "Editar dados cadastrais", 8, _hoisted_27),
                        (_ctx.apresentarConfiguracoesDocumentosFiscaisEletronicos(empresa.codigo))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "ant-btn ant-btn-block ant-btn-secondary ss-margin-botoes ss-btn-acao-destaque",
                              onClick: ($event: any) => (_ctx.editarConfiguracoes(empresa.codigo))
                            }, "Documentos Fiscais", 8, _hoisted_28))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "ant-btn ant-btn-block ant-btn-secondary ss-margin-botoes ss-btn-acao-destaque",
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.abrirPlanoAssinatura && _ctx.abrirPlanoAssinatura(...args)))
                            }, "Plano Contratado")
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
                ((_ctx.state.grupoEmpresa.codigo === 0))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _hoisted_36,
                            _hoisted_37,
                            _hoisted_38,
                            _createTextVNode(" Administre várias empresas a partir de uma única plataforma. "),
                            _hoisted_39,
                            _hoisted_40,
                            _createTextVNode(" Consolide dados financeiros e relatórios de todas as suas empresas. "),
                            _hoisted_41,
                            _hoisted_42,
                            _createTextVNode(" Compartilhe recursos e informações entre suas empresas para aumentar a eficiência. "),
                            _hoisted_43,
                            _hoisted_44,
                            _createTextVNode(" Controle o acesso de usuários a diferentes empresas conforme suas necessidades. "),
                            _hoisted_45,
                            _createElementVNode("button", {
                              type: "button",
                              class: "ant-btn ant-btn-block ant-btn-secondary ss-margin-botoes ss-btn-acao-destaque",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.apresentarModalGrupoEmpresa = true))
                            }, "Criar grupo para gerenciar várias empresas"),
                            _hoisted_46,
                            _createElementVNode("button", {
                              type: "button",
                              class: "ant-btn ant-btn-block ant-btn-secondary ss-margin-botoes ss-btn-acao-destaque",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.apresentarModalAdicionarEmpresa = true))
                            }, "Possuo um Token e desejo adicionar minha empresa no Multi-Empresas")
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _createVNode(_component_empresa_dados_cadastrais_modal, {
      visivel: _ctx.state.exibirEditarDadosCadastrais,
      "onUpdate:visivel": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.exibirEditarDadosCadastrais) = $event)),
      operacao: _ctx.state.editarDadosCadastrais,
      "onUpdate:operacao": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.editarDadosCadastrais) = $event))
    }, null, 8, ["visivel", "operacao"]),
    _createVNode(_component_adicionar_empresa_grupo_modal, {
      visivel: _ctx.state.apresentarModalAdicionarEmpresa,
      "onUpdate:visivel": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.apresentarModalAdicionarEmpresa) = $event)),
      token: _ctx.state.tokenGrupoMultiEmpresas,
      "onUpdate:token": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.tokenGrupoMultiEmpresas) = $event)),
      onAdicionadaComSucesso: _ctx.empresaAdicionadaComSucesso
    }, null, 8, ["visivel", "token", "onAdicionadaComSucesso"]),
    _createVNode(_component_configuracao_documentos_fiscais_eletronicos_modal, {
      visivel: _ctx.state.exibirModalCondiguracoesDocumentoFiscalEletronico,
      "onUpdate:visivel": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.exibirModalCondiguracoesDocumentoFiscalEletronico) = $event)),
      empresa: _ctx.state.empresaSelecionada,
      limitesDocumentosFiscais: _ctx.state.limitesDocumentosFiscaisEmpresa,
      onAtualizarTokenFiscal: _cache[17] || (_cache[17] = ($event: any) => (_ctx.atualizarTokenFiscal()))
    }, null, 8, ["visivel", "empresa", "limitesDocumentosFiscais"]),
    _createVNode(_component_plano_assinatura_empresa_modal, {
      visivel: _ctx.state.exibirPlanoAssinatura,
      "onUpdate:visivel": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.exibirPlanoAssinatura) = $event))
    }, null, 8, ["visivel"]),
    _createVNode(_component_a_modal, {
      width: "600px",
      centered: "",
      visible: _ctx.state.apresentarModalGrupoEmpresa,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.apresentarModalGrupoEmpresa) = $event)),
      title: "Grupo de Empresas",
      footer: null
    }, {
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createVNode(_component_a_form_item, {
                  label: "Nome",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.grupoEmpresa.nome) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.grupoEmpresa.nome]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createVNode(_component_a_form_item, {
                  label: " ",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.criarGrupo && _ctx.criarGrupo(...args))),
                      type: "button",
                      class: "ant-btn ant-btn-block ant-btn-primary"
                    }, _hoisted_51)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}